// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"44":"cac9e98d32b76afc","482":"d227d3ed95e7a948","520":"294aae2742516dd4","674":"baaed13a892a9c81","722":"37df77e2c1a54340","837":"d7ec0e29b69f6801","861":"7c919fd4df8afb76"}[chunkId] + ".js";
};